import classNames from 'classnames'
import React, { useState } from 'react'
import { ProjectSelectionFilterProps } from './types'
import { CategorySelection, LocationSelection } from 'src/discover'
import { Search, useMobile } from 'src/shared'

export const ProjectSelectionFilter = ({
  categories,
  categoryChanged,
  categoryId,
  query,
  queryChanged,
  bounds,
  boundsChanged,
  locations,
}: ProjectSelectionFilterProps): JSX.Element => {
  const mobile = useMobile()
  const [showFilters, setShowFilters] = useState(mobile ? false : true)
  const activeFilters = categoryId || query || bounds

  const toggleFilters = () => {
    setShowFilters(!showFilters)
    const ele = document.activeElement as HTMLElement | null
    ele?.blur()
  }

  return (
    <>
      {mobile && (
        <div className="w-full flex justify-center">
          <div className="relative">
            <button
              type="button"
              className={classNames(
                'relative btn btn-large btn-toggle has-icon',
                showFilters === true && 'toggled mb-3'
              )}
              onClick={toggleFilters}
            >
              <i className="fas fa-sliders-h fa-sm text-green-800 mr-2"></i>
              <span>Filter</span>
            </button>
            {activeFilters && <div className="indicator" />}
          </div>
        </div>
      )}
      {showFilters && (
        <div className="container">
          <div className="row">
            <div className="col-md-16 offset-md-4 flex flex-col desktop:flex-row">
              <div className="desktop:w-px desktop:basis-1/2 grow shrink-0  px-3 mb-3">
                <label>{i18n.t('discover.categories.index.filter_bar_parts.location')}</label>
                <LocationSelection bounds={bounds} boundsChanged={boundsChanged} locations={locations} />
              </div>
              <div className="desktop:w-px desktop:basis-1/2 grow shrink-0  px-3 mb-3">
                <label className="block">{i18n.t('fundraising_events.preselections.show.label_category_filter')}</label>
                <CategorySelection categories={categories} categoryChanged={categoryChanged} categoryId={categoryId} />
              </div>
            </div>
            <div className="col-md-16 offset-md-4 flex flex-col desktop:flex-row">
              <div className="flex-1 px-3">
                <Search
                  queryChanged={queryChanged}
                  query={query}
                  placeholder={i18n.t('fundraising_events.preselections.show.placeholder_search_filter')}
                  label={i18n.t('fundraising_events.preselections.show.label_search_filter')}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
